import { Component } from '@angular/core';
import { Service } from './service';
import { MatRadioChange } from '@angular/material/radio';
import { Observable } from 'rxjs/internal/Observable';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Financial Advisor Evaluation';
  isShown:boolean=false;

  constructor( public quiz: Service){
  
  

  }


}
